<template>
    <div class="child-news ">
        <div class="child-news-main">
            <div class="child-news-main-content" v-loading="loading"  element-loading-background="rgba(0, 0, 0, 0)" :style="{'width':showPopularNews ? 'calc(100% - 454px)' : '100%'}">
                <div class="child-news-main-content-list">
                    <div v-for="(newsItem,index) in data" :key="index" @click="$emit('go-to-news-detail',newsItem, index)"
                         class="child-news-main-content-list-item keep-hue" @mouseenter="hoverStatus=index" @mouseleave="hoverStatus=-1" :class="{'child-news-main-content-list-item-hoverStatus' : hoverStatus=== index}">
                        <NewsItemCommon :data="newsItem"/>
                    </div>
                    <div class="pagesPag" v-if="data.length > 0">
                        <el-pagination
                                background
                                @current-change="handleCurrentChange"
                                :current-page="pageNo"
                                :page-size="pageSize"
                                @size-change="handleSizeChange"
                                layout="total,sizes,prev, pager, next, jumper"
                                :total="totalCount">
                        </el-pagination>

                    </div>

                    <NoData v-if="data.length === 0 && !loading" type="list" style="padding-top: 75px"/>
                </div>
            </div>
<!--            <div class="child-news-main-ad">-->
<!--                <img :src="require(`@/assets/NewsCenter/newsListSide.png`)"/>-->
<!--            </div>-->
            <div class="child-news-main-ad"  v-if="showPopularNews">
                <PopularNews
                        class="hot-news"
                        :serveUrl="serveUrl"
                        :request="request"
                        :columnId="columnId"
                />

            </div>
        </div>
    </div>
</template>

<script>
    import NewsItemCommon from "./newsItemCommon";
    import NoData from './noData.vue';
    import {mapGetters} from "vuex";
    import PopularNews from './PopularNews'
    import configR from '@/configs.js';
    import request from '@/utils/request';
    export default {
        name: "childNewsList",
        data(){
            return {
                hoverStatus: -1
            }
        },
        computed: {
            ...mapGetters(["token", "serveUrl", "request"]),
          showPopularNews(){
               // 是否显示热门资讯,SHOW_NEWS_DETAIL 为1 显示，其他值不显示
            if(!this.columnId) {
              return false;
            }
              return configR.envConfigs.SHOW_NEWS_DETAIL === '1' || !this.columnId.startsWith('remote-') ;
          },
         serveUrl(){
          return configR.envConfigs.PORTAL_API
         },
        request(){
          return request
        },
        },
        props: {
            data: { type: Array, default: () => []},
            columnName: { type: String, default: ''},
            loading:  { type: Boolean, default: true},
            pageNo: { type: Number, default: 1},
            pageSize: { type: Number, default: 10},
            totalCount: { type: Number, default: 0},
            onOffSearchMore: { type: Boolean, default: true},
          columnId: { type: String, default: ''},
        },
        components: {
            NewsItemCommon,
            NoData,
            PopularNews
        },
        methods: {
            handleCurrentChange(pageNo){
                this.$emit('search-more',{pageNo:pageNo,pageSize:this.pageSize});
            },
          handleSizeChange(pageSize) {
            this.$emit('search-more',{pageNo:1,pageSize:pageSize});
          }
        }
    }
</script>

<style scoped lang="scss" >
  @import "@/styles/variables.scss";
    .child-news {
        width: 100%;
        &-main {
            display: flex;

            &-content {
                background: rgba(255, 255, 255, 0.96);
                width:calc(100% - 454px);
                min-height: calc(100vh - 250px);
                border-radius: 6px;
                &-list {
                  padding-top: 20px;
                    &-item {
                        padding: 0 40px;
                        &:last-child {
                            border-bottom: none;
                        }
                        &-hoverStatus {
                            /*box-shadow: 0px 1px 10px 0px rgba(14, 108, 203, 0.1);*/
                            /*background-color: rgba(255, 255, 255, 1);*/
                         /deep/ .title {
                            color: $color-primary;
                            transition: all 0.4s;
                          }

                            cursor: pointer;
                        }
                    }
                    .pagesPag {
                        padding: 30px 40px;
                        /deep/ .el-pagination {
                          display: flex;
                          & span:not([class*=suffix]) {
                            font-size: 14px;
                            height: 32px;
                            line-height: 32px;
                          }
                          span.el-pagination__sizes {
                            flex: 1;
                          }
                        }
                        /deep/ .el-pagination.is-background .el-pager li, /deep/ .el-pagination.is-background .btn-prev,/deep/ .el-pagination.is-background .btn-next {
                            border-radius: 6px;
                            border: 1px solid #D3D3D3;
                            background: none;
                          font-size: 14px;
                          width: 32px;
                          height: 32px;
                          line-height: 32px;
                        }
                      /deep/ .el-pagination.is-background .el-pager li.number.active {
                        background-color:$color-primary;
                        border: none;
                      }

                    }
                }
            }
            &-ad {
                width: 434px;
                min-height: 900px;
                margin-left: 20px;
                overflow: hidden;
                flex-grow: 1;
                img {
                    max-width: 100%;
                    min-height: 100%;
                    border-radius: 6px;
                }
            }
        }

    }




</style>